import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconServerCog } from '@tabler/icons-react';

/**
 * Used to insert a device loop into the editor.
 */
export default function InsertDeviceLoop({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconServerCog />}
      label="Opakovač zariadení"
      onClick={() => editor?.chain().focus().setDeviceLoop().run()}
    />
  );
}
